import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import {makeToolTipUrl} from "utils/DBUtils";
import {enUSmessage} from 'i18n/en-US.js';

export const TextTriviaHeadlineToolTip = (props) => (
  <div>
    The title of the break featured on top.
    <br/>
    <img src={makeToolTipUrl('texttrivia/1.CMS-trivia-headline.png')} width="100%"/>
  </div>
);

export const TextTriviaIntroCopyToolTip = (props) => (
  <div>
    Copy to introduce an overview of the break.
    <br/>
    <img src={makeToolTipUrl('texttrivia/2.CMS-trivia-intro.png')} width="100%"/>
  </div>
);

export const TextTriviaDefaultButtonBkgdColorToolTip = (props) => (
  <div>
    Color on the trivia answer buttons. Will prefill with brand theme color in sponsored breaks and default dark blue for editorial.
    <br/>
    <img src={makeToolTipUrl('texttrivia/3.CMS-trivia-default-button-color.png')} width="100%"/>
  </div>
);

export const TextTriviaDefaultButtonTextColorToolTip = (props) => (
  <div>
    Color of text on the trivia answer buttons. Will prefill with brand theme text color in sponsored breaks.
    <br/>
    <img src={makeToolTipUrl('texttrivia/4.CMS-trivia-default-button-text.png')} width="100%"/>
  </div>
);

export const TextTriviaQuestionToolTip = (props) => (
  <div>
    A question to prompt the user to respond.
    <br/>
    <img src={makeToolTipUrl('texttrivia/5.CMS-trivia-question.png')} width="100%"/>
  </div>
);

export const TextTriviaQuestionImageToolTip = (props) => (
  <div>
    Image that relates to the question.
    <br/>
    <img src={makeToolTipUrl('texttrivia/6.CMS-trivia-question-img.png')} width="100%"/>
  </div>
);

export const TextTriviaAnswerToolTip = (props) => (
  <div>
    Results that appears as a button under the question.
    <br/>
    <img src={makeToolTipUrl('texttrivia/7.CMS-trivia-answer.png')} width="100%"/>
  </div>
);

export const TextTriviaAnswerImageToolTip = (props) => (
  <div>
    Image option to answer the question. Appears as a button under the question.
    <br/>
    <img src={makeToolTipUrl('texttrivia/8.CMS-trivia-answer-img.png')} width="100%"/>
  </div>
);

export const TextTriviaAnswerCorrectToolTip = (props) => (
  <div>
    If yes, this is the correct answer to the question. If no, this is a false answer or wrong.
  </div>
);

export const TextTriviaAnswerEditButtonColorsToolTip = (props) => (
  <div>
    If yes, this will allow you to override the default button colors set above.
  </div>
);

export const TextTriviaAnswerButtonBkgdColorToolTip = (props) => (
  <div>
    Override to the color on the trivia answer buttons.
  </div>
);

export const TextTriviaAnswerButtonTextColorToolTip = (props) => (
  <div>
    Override to the color of text on the trivia answer buttons.
  </div>
);

export const TextTriviaQuestionResponseTextToolTip = (props) => (
  <div>
    Copy describing the correct answer.
    <br/>
    <img src={makeToolTipUrl('texttrivia/9.CMS-trivia-question-response-text.png')} width="100%"/>
  </div>
);

export const TextTriviaQuestionResponseImageToolTip = (props) => (
  <div>
    Image that overrides the “question image.” This image will be covered by a color overlay and response text. 
    <br/>
    <img src={makeToolTipUrl('texttrivia/10.CMS-trivia-question-response-img.png')} width="100%"/>
  </div>
);

export const TextTriviaResultTitleToolTip = (props) => (
  <div>
    Copy relating to the content and reader’s performance in the trivia.
    <br/>
    <img src={makeToolTipUrl('texttrivia/11.CMS-trivia-results-title.png')} width="100%"/>
  </div>
);

export const TextTriviaResultDescriptionToolTip = (props) => (
  <div>
    Extended copy relating to the content and reader’s performance in the trivia.
    <br/>
    <img src={makeToolTipUrl('texttrivia/12.CMS-trivia-results-description.png')} width="100%"/>
  </div>
);

export const TextTriviaResultMinCorrectToolTip = (props) => (
  <div>
    The minimum number of questions a reader can get wrong and still attain this result.
  </div>
);

export const TextTriviaResultMaxCorrectToolTip = (props) => (
  <div>
    The maximum number of questions a reader can get correct and still attain this result.
  </div>
);

export const TextTriviaResultImageToolTip = (props) => (
  <div>
    Image that relates the the result.
    <br/>
    <img src={makeToolTipUrl('texttrivia/13.CMS-trivia-results-img.png')} width="100%"/>
  </div>
);

export const TextTriviaUseDifferentSocialImageToolTip = (props) => (
  <div>
    If yes, you can override the default “Facebook and social image.”
  </div>
);

export const TextTriviaResultSocialImageToolTip = (props) => (
  <div>
    Image that will appear when sharing a break on Facebook and Pinterest for this result.
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/text-trivia-tool-tips.jsx